package org.ssoft.common.type

@Suppress("ClassName")
sealed class DashboardType(
    override var mask: Int,
    @Suppress("unused") val category: DashboardCategory
) : Mask {

    /** 2 */
    data object NONE : DashboardType(2, DashboardCategory.UNDEFINED)

    /** 4 */
    data object CAMPAIGN_GLOBAL : DashboardType(4, DashboardCategory.CAMPAIGN)
    /** 8 */
    data object CAMPAIGN_TODAY : DashboardType(8, DashboardCategory.CAMPAIGN)

    /** 256 */
    data object DEVICE_LAYER_COUNTER : DashboardType(256, DashboardCategory.DEVICE)
    /** 512 */
    data object PROBLEMS_DEVICE : DashboardType(512, DashboardCategory.DEVICE)
    /** 1024 */
    data object PROBLEMS_CAMPAIGN : DashboardType(1024, DashboardCategory.CAMPAIGN)
    /** 2048 */
    data object COMPANY_STORAGE : DashboardType(2048, DashboardCategory.COMPANY)

    companion object {

        val all by lazy {
            listOf(
                NONE,

                CAMPAIGN_GLOBAL,
                CAMPAIGN_TODAY,

                DEVICE_LAYER_COUNTER,
                PROBLEMS_DEVICE,
                PROBLEMS_CAMPAIGN,
                COMPANY_STORAGE
            )
        }

        operator fun get(mask: Int): DashboardType = Mask[mask, all] ?: NONE
    }

    override fun toString(): String = mask.toString()

    override fun hashCode(): Int = mask

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as DashboardType

        return mask == other.mask
    }
}